import React from 'react';
import './Category.css';

import { renderIcon } from '../../utils';

import { Link } from 'react-router-dom';



const Category = (props) => {

  // Destructuring props
  const { category, count, image } = props;

  return (

    <div key={category} className="category-item">

      <img src={image} alt={category} /> {/* Category Image */}

      <div className="content">
        <div className="text">
          <Link to={`/Cars?type=${encodeURIComponent(category)}`}> {/* Link to Filtered Cars Page */}
            <h3>{category}</h3> {/* Category Name */}
          </Link>
          <div className="label">{count} cars available</div> {/* Number of Listings */}
        </div>
        <div className="icon">{renderIcon(category)}</div> {/* Category Icon */}
      </div>

    </div>

  );
};

export default Category;